import { KEYWORDS } from "./support";
const nodeEnv =  window.configs && window.configs.NODE_ENV !== "" 
? window.configs.NODE_ENV: process.env.NODE_ENV;
export const EMPLOYEE_MENU = {
  FIRST_CHUNK: [
    {
      name: "employee-home",
      route: "employee-home",
    },
    {
      name: "employee-profile",
      route: "employee-profile",
    },
  ],
  CHUNK_WITH_DROPDOWN: [
    {
      name: "employee-planning",
      items: [
        {
          name: "employee-planning",
          route: "employee-schedule",
        },
        {
          name: "employee-schedule-wishes",
          route: "employee-schedule-wishes",
        },
        {
          name: "employee-leave",
          route: "employee-leave",
        },
      ],
    },
    {
      name: "Vitalliance",
      items: [
        {
          name: "employee-agency",
          route: "employee-agency",
        },
        {
          name: "employee-documents",
          route: "employee-documents",
        },
        {
          name: "employee-message",
          multiConditions: [
            "rcfchatadvagency",
            "rcfchatadvteam",
            "rcfchatadvteamclient",
          ],
          route: "employee-message",
          // hidden: process.env.NODE_ENV !== "development",
        },
        {
          name: "employee-news",
          route: "employee-news",
        },
        {
          name: "employee-reclamation",
          route: "employee-reclamation",
        },
        {
          name: "employee-training",
          route: "employee-training",
          hidden: nodeEnv !== "development",
        },
        {
          name: "employee-telemanagement",
          route: "employee-telemanagement",
        },
        {
          name: "employee-my-contract",
          route: "employee-my-contract",
        },
        {
          name: "employee-list",
          route: "employee-list",
          hidden: nodeEnv !== "development",
        },
        {
          name: "employee-classification",
          route: "employee-classification",
        },
        {
          name: "employee-psychological-support",
          route: "employee-support",
          key: "rcfsoutienpsy",
          params: { keyword: KEYWORDS.PSYCHOLOGIC },
        },
        {
          name: "employee-social-support",
          route: "employee-support",
          key: "rcfsoutiensocial",
          params: { keyword: KEYWORDS.SOCIAL },
        },
      ],
    },
    {
      name: "employee-missions",
      items: [
        {
          name: "employee-missions-en-cours",
          route: "employee-missions",
        },
        {
          name: "employee-assignment-offer",
          route: "employee-assignment-offer",
          hidden: nodeEnv !== "development",
        },
      ],
    },
  ],
  SECOND_CHUNK: [
    {
      name: "employee-support-business",
      route: "employee-support-business",
      key: "rcfbusinesssupport",
    },
    {
      name: "employee-support-technique",
      route: "employee-support-technique",
    },
  ],
  THIRD_CHUNK: [
    {
      name: "employee-documents",
      route: "employee-documents",
    },
  ],
};

export const MESSAGE_POPUP = {
  TYPE: "current_adv",
};
